import React, {useState, useEffect} from "react";
import Head from 'next/head'
import {useRouter} from "next/router";
import TopLine from "../components/common/TopLine";

export default function BlogLayout(
    {
        children,
        title,
        description,
        keywords,
        canonical,
        page
    }) {

    const router = useRouter();

    const [origin, setOrigin] = useState('')
    const [host, setHost] = useState('')

    useEffect(() => {
        setOrigin(window.location.origin)
        setHost(window.location.host)
    }, [])

    return (
        <>
            <Head>
                <title>{title}</title>
                <link rel="icon" type="image/png" href="/img/icons/favicon-96x96.png" sizes="96x96"/>
                <link rel="icon" type="image/svg+xml" href="/img/icons/favicon.svg"/>
                <link rel="shortcut icon" href="/img/icons/favicon.ico"/>
                <link rel="apple-touch-icon" sizes="180x180" href="/img/icons/apple-touch-icon.png"/>
                <meta name="apple-mobile-web-app-title" content="ColdWare"/>
                <link rel="manifest" href="/site.webmanifest"/>
                <meta name="msapplication-TileColor" content="#da532c"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description" content={description}/>
                <meta name="keywords" content={keywords}/>
                <link rel="canonical"
                      href={router.locale === 'en' ? `${origin}/${canonical}` : `${origin}/${router.locale}/${canonical}`}/>
                <meta property="og:url" content={origin}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content=''/>
                <meta property="og:description" content=''/>
                <meta property="og:image" content={`${origin}/img/main/og.png`}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content={host}/>
                <meta property="twitter:url" content={host}/>
                <meta name="twitter:title" content=''/>
                <meta name="twitter:description" content=''/>
                <meta name="twitter:image" content={`${origin}/img/main/og.png`}/>
            </Head>
            <div className={page}>
                <TopLine/>
                {children}
            </div>
        </>
    )
}